var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 2C13.2962 2 14.0592 2.31607 14.6218 2.87868C15.1844 3.44129 15.5005 4.20435 15.5005 5C15.5005 5.79565 15.1844 6.55871 14.6218 7.12131C14.0592 7.68391 13.2962 7.99997 12.5005 7.99997H3.50049C2.70484 7.99997 1.94178 7.68391 1.37917 7.12131C0.816557 6.55871 0.500488 5.79565 0.500488 5C0.500488 4.20435 0.816557 3.44129 1.37917 2.87868C1.94178 2.31607 2.70484 2 3.50049 2H12.5005Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 8C12.8944 8 13.2846 8.0776 13.6486 8.2284C14.0125 8.37913 14.3432 8.60013 14.6218 8.87873C14.9004 9.15727 15.1214 9.488 15.2721 9.852C15.4229 10.2159 15.5005 10.6061 15.5005 11C15.5005 11.394 15.4229 11.7841 15.2721 12.1481C15.1214 12.5121 14.9004 12.8428 14.6218 13.1213C14.3432 13.3999 14.0125 13.6209 13.6486 13.7717C13.2846 13.9224 12.8944 14 12.5005 14H3.50049C2.70484 14 1.94178 13.6839 1.37917 13.1213C0.816557 12.5587 0.500488 11.7957 0.500488 11C0.500488 10.2044 0.816557 9.44133 1.37917 8.87873C1.94178 8.31613 2.70484 8 3.50049 8H12.5005Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00049 5H12.5005",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00049 11H12.5005",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25C2.86193 5.25 2.75 5.13807 2.75 5C2.75 4.86193 2.86193 4.75 3 4.75",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.25C3.13807 5.25 3.25 5.13807 3.25 5C3.25 4.86193 3.13807 4.75 3 4.75",
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.25C2.86193 11.25 2.75 11.1381 2.75 11C2.75 10.8619 2.86193 10.75 3 10.75",
    stroke: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.25C3.13807 11.25 3.25 11.1381 3.25 11C3.25 10.8619 3.13807 10.75 3 10.75",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepo);
export default __webpack_public_path__ + "static/media/repo.72ecca87.svg";
export { ForwardRef as ReactComponent };